import React, { type PropsWithChildren } from 'react';

import { BodyText } from '@garnish/core';

export const HowItWorksHeaderTitle = (props: PropsWithChildren) => {
  return <BodyText sizeMatch={['16']}>{props.children}</BodyText>;
};
